import { type Game } from '../../../mocks/games';

interface Props {
  game: Game;
  onClose: () => void;
  onStart: () => void;
}

export default function GameIntroModal({ game, onClose, onStart }: Props) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/40 backdrop-blur-sm">
      <div className="bg-white rounded-3xl max-w-lg w-full overflow-hidden">
        {/* Header image */}
        <div className="relative h-52">
          <img
            src={game.image}
            alt={game.title}
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
          <button
            onClick={onClose}
            className="absolute top-4 right-4 w-9 h-9 flex items-center justify-center bg-white/80 rounded-full cursor-pointer hover:bg-white transition-colors"
          >
            <i className="ri-close-line text-primary-brown-dark"></i>
          </button>
          {game.tag && (
            <span className="absolute top-4 left-4 px-3 py-1 bg-primary-orange text-white text-xs font-bold rounded-full">
              {game.tag}
            </span>
          )}
        </div>

        {/* Content */}
        <div className="p-6">
          <h2 className="text-2xl font-bold text-primary-brown-dark mb-3">{game.title}</h2>
          <p className="text-primary-brown-light text-sm leading-relaxed mb-5">{game.description}</p>

          {/* Quick info */}
          <div className="grid grid-cols-2 gap-3 mb-6">
            <div className="bg-primary-cream rounded-2xl p-3 text-center">
              <div className="w-8 h-8 flex items-center justify-center mx-auto mb-1">
                <i className="ri-time-line text-xl text-primary-orange"></i>
              </div>
              <p className="text-xs text-primary-brown-light">Thời gian</p>
              <p className="text-sm font-bold text-primary-brown-dark">{game.duration}</p>
            </div>
            <div className="bg-primary-cream rounded-2xl p-3 text-center">
              <div className="w-8 h-8 flex items-center justify-center mx-auto mb-1">
                <i className={`${game.category === 'Đồng đội' ? 'ri-team-line' : 'ri-user-line'} text-xl text-primary-orange`}></i>
              </div>
              <p className="text-xs text-primary-brown-light">Loại</p>
              <p className="text-sm font-bold text-primary-brown-dark">{game.category}</p>
            </div>
          </div>

          <div className="flex gap-3">
            <button
              onClick={onClose}
              className="flex-1 py-3 border-2 border-primary-brown-light/20 rounded-xl text-primary-brown-light font-semibold hover:border-primary-orange hover:text-primary-orange transition-all cursor-pointer whitespace-nowrap"
            >
              Để sau
            </button>
            <button
              onClick={onStart}
              className="flex-1 py-3 bg-gradient-to-r from-primary-orange to-primary-yellow text-white font-bold rounded-xl hover:opacity-90 transition-all cursor-pointer whitespace-nowrap"
            >
              Xem hướng dẫn
              <i className="ri-arrow-right-line ml-2"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
